
import { Component, Vue } from 'vue-property-decorator'
import GrantUserInfo from './tabs/grantuserinfo.vue'
import UpdateLog from './tabs/updatelog.vue'
import util from '@/utils/busi/util'
import { addProUser, upDateProUser } from '@/api/agentcenter'

@Component({
  name: 'grant-detail',
  components: {
    GrantUserInfo,
    UpdateLog
  }
})

export default class GrantDetail extends Vue {
  private activeName = 'GrantUserInfo'

  private params: any = util.getRouterParams()

  get onlyView () {
    return this.params.onlyView
  }

  get isEdit () {
    return this.params.flag === 'edit'
  }

  private validate () {
    (this.$refs.com as any).validate(() => {
      this.onSave()
    })
  }

  private async onSave () {
    const params: any = util.trimForm({ ...this.params })
    const presenterId = params.presenterId ? params.presenterId.split(',') : null
    const proType = params.proType.split(',')
    const proTypes: any = []
    if (presenterId) {
      params.presenterId = presenterId[presenterId.length - 1].split('-')
    } else {
      params.presenterId = ['-1', '-1']
    }
    if (!params.proLevel) {
      params.proLevel = 1
    }
    proType.map((v: any) => {
      const item = v.split('-')
      if (item[1] && item[1] !== 'null' && item[1] !== 'undefined') {
        proTypes.push({
          userId: params.id,
          proType: item[0],
          businessId: item[1] || '1'
        })
      }
    })
    if (params.settlementMethod === 1 && (!params.payee || !params.openAccountBank || !params.openAccountAddress || !params.bankAccount)) {
      this.$message.error('收款人具体信息不能为空')
      return
    }
    if (this.isEdit) {
      if (!params.presenterId[0] || params.presenterId[0].length === 0) params.presenterId[1] = -1
      await upDateProUser({
        id: params.id,
        presenter: params.presenterId[1],
        presenterId: params.presenterId[0],
        userAccount: params.userAccount,
        userName: params.userName,
        pwd: params.pwd,
        phone: params.phone,
        wechat: params.wechat,
        settlementMethod: params.settlementMethod,
        payee: params.payee,
        openAccountBank: params.openAccountBank,
        openAccountAddress: params.openAccountAddress,
        bankAccount: params.bankAccount,
        state: params.state,
        scanStatus: params.scanStatus,
        tbsUserId: params.tbsUserId,
        deadline: params.deadline * 1 + (24 * 60 * 60 * 1000 - 1),
        memo: params.memo,
        proLevel: params.proLevel,
        lbUserProTypes: proTypes
      }).then((res: any) => {
        if (res.code === 10000) {
          this.$message(res.message)
          this.onBack()
        }
      })
    } else {
      await addProUser({
        presenter: params.presenterId[1],
        presenterId: params.presenterId[0],
        userAccount: params.userAccount,
        userName: params.userName,
        pwd: params.pwd,
        phone: params.phone,
        wechat: params.wechat,
        settlementMethod: params.settlementMethod,
        payee: params.payee,
        openAccountBank: params.openAccountBank,
        openAccountAddress: params.openAccountAddress,
        bankAccount: params.bankAccount,
        state: params.state,
        scanStatus: params.scanStatus,
        deadline: params.deadline * 1 + (24 * 60 * 60 * 1000 - 1),
        memo: params.memo,
        proLevel: params.proLevel,
        lbUserProTypes: proTypes
      }).then((res: any) => {
        if (res.code === 10000) {
          this.$message(res.message)
          this.onBack()
        }
      })
    }
  }

  private onBack () {
    this.$router.push({
      name: 'agentUserManagement'
    })
  }
}
